/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { WardrobeItem } from '../types';
import { CDN_URLS } from '../config';

const RETAILER_ITEMS: Record<string, Partial<WardrobeItem>[]> = {
    'Zara': [
        { nameKey: 'wardrobe_item_zara_blazer', category: 'Jackets', url: `${CDN_URLS.UNSPLASH}photo-1548126032-079a0fb0099d?w=400`, brand: 'Zara', type: 'garment' },
        { nameKey: 'wardrobe_item_zara_trousers', category: 'Bottoms', url: `${CDN_URLS.UNSPLASH}photo-1594633312681-425c7b97ccd1?w=400`, brand: 'Zara', type: 'garment' },
    ],
    'H&M': [
        { nameKey: 'wardrobe_item_hm_knitwear', category: 'Tops', url: `${CDN_URLS.UNSPLASH}photo-1434389677669-e08b4cac3105?w=400`, brand: 'H&M', type: 'garment' },
        { nameKey: 'wardrobe_item_hm_skirt', category: 'Bottoms', url: `${CDN_URLS.UNSPLASH}photo-1582142324433-18ac78715d5a?w=400`, brand: 'H&M', type: 'garment' },
    ],
    'Zalando': [
        { nameKey: 'wardrobe_item_zalando_sneakers', category: 'Shoes', url: `${CDN_URLS.UNSPLASH}photo-1549298916-b41d501d3772?w=400`, brand: 'Zalando', type: 'accessory' },
        { nameKey: 'wardrobe_item_zalando_dress', category: 'Dresses', url: `${CDN_URLS.UNSPLASH}photo-1595777457583-95e059d581b8?w=400`, brand: 'Zalando', type: 'garment' },
    ],
    'ASOS': [
        { nameKey: 'wardrobe_item_asos_denim', category: 'Bottoms', url: `${CDN_URLS.UNSPLASH}photo-1542272454315-4c01d7abdf4a?w=400`, brand: 'ASOS', type: 'garment' },
        { nameKey: 'wardrobe_item_asos_shacket', category: 'Jackets', url: `${CDN_URLS.UNSPLASH}photo-1576995853123-5a10305d93c0?w=400`, brand: 'ASOS', type: 'garment' },
    ],
};

export const generateItemsFromRetailers = (retailers: string[]): WardrobeItem[] => {
    const newItems: WardrobeItem[] = [];

    retailers.forEach(retailer => {
        const items = RETAILER_ITEMS[retailer];
        if (items) {
            items.forEach((item, index) => {
                newItems.push({
                    ...item,
                    id: `retail-${retailer.toLowerCase()}-${Date.now()}-${index}`,
                    nameKey: item.nameKey || `wardrobe_item_${retailer.toLowerCase()}_${index}`,
                    url: item.url || '',
                    type: item.type || 'garment',
                } as WardrobeItem);
            });
        }
    });

    return newItems;
};
